<small class="debug">{{me}}</small>
<mat-label>{{'general.generateLinkScene' | transloco}}</mat-label>
<mat-form-field>
  <mat-select (selectionChange)="onSceneChange()" [(value)]="assignedScene">
    @for (scene of this.scenesSimple; track scene) {
      <mat-option [value]="scene">
        {{scene.name}}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
<mat-divider></mat-divider>
@if (dynamicsInitialized) {
  <div>
    <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
    </dynamic-form>
    <hr/>
  </div>
}
@if (showCode) {
  <div style="border: dotted 2px black">
    <a mat-button matTooltip="{{'general.toClipboard' | transloco}}"
      (click)="onCopy()" mat-flat-button [cdkCopyToClipboard]="snippet.value">
      <mat-icon style="font-size: 2em">file_copy</mat-icon>
    </a>
    <textarea style="height: 100px; width: 240px" id="snippet" #snippet disabled>
      <head>
        <meta http-equiv="content-type" content="text/html; charset=utf-8" />
        <title>www.com</title>
        <script type="text/javascript">;
          if(self != top) top.location.href = 'http://'+location.hostname+'/?redir=frame&uid=www5ea9a909a84691.03256682';
        </script>
        <script type="text/javascript" src="http://ajax.googleapis.com/ajax/libs/jquery/1.5.2/jquery.min.js"></script>
        <script type="text/javascript">
          function GetParam(name) {
          var match = new RegExp(name +
          "=*([^&]+)*", "i").exec(location.search);
          if (match == null)
          match = new RegExp(name + "=(.+)", "i").exec(location.search);
          if (match == null) return null;
          match = match + "";
          //**convert match to a string
          result = match.split(",");
          return decodeURIComponent(result[1]);
        }
        function logStatus(type) {
        $.ajax({
        cache: false,
        global: false,
        async: true,
        type: "POST",
        url: '/logpstatus.php',
        data: {uid: GetParam('uid'), type: type}
        });
      }
    </script>
  </head>
  <frameset cols="1,*,1" border=0>
    <frame name="top" src="tg.php?uid=www5ea9a909a84691.03256682" scrolling=no frameborder=0 noresize framespacing=0 marginwidth=0 marginheight=0>
      <frame src="search_caf.php?uid=www5ea9a909a84691.03256682&src=mountains&abp=1" scrolling="auto" framespacing=0 marginwidth=0 marginheight=0 noresize>
        <frame src="page.php?www5ea9a909a84691.03256682"></frame>
      </frameset>
      <noframes>
      </noframes>
    </textarea>
  </div>
}






